@if (toasts().length) {
  <div class="pointer-events-none fixed top-4 right-4 z-[100] flex flex-col items-end gap-2">
    @for (toast of toasts(); track toast.id) {
      <div
        class="pointer-events-auto grid w-full max-w-sm grid-cols-[1fr_auto] items-center gap-3 rounded-lg border px-4 py-3 shadow-lg"
        [class.bg-success]="toast.type === 'success'"
        [class.border-success]="toast.type === 'success'"
        [class.bg-warning]="toast.type === 'warning'"
        [class.border-warning]="toast.type === 'warning'"
        [class.bg-error]="toast.type === 'error'"
        [class.border-error]="toast.type === 'error'"
      >
        <p class="text-left text-sm font-medium text-white">{{ toast.message }}</p>
        <button
          type="button"
          class="justify-self-end text-white/80 hover:text-white"
          aria-label="Cerrar"
          (click)="onDismiss(toast.id)"
        >
          ✕
        </button>
      </div>
    }
  </div>
}
